module.exports = __webpack_public_path__ + "img/no-img.42b64968.png";